
  
  
  export default {
    data() {
      return {
  
        form: {
            id: null,
            nama: '',
            bidang_usaha_id: '',
            email: '',
            hp: '',
            alamat: ''
          },

        filterku: {
          master_bidang_usaha: ''  // filter pakai bidang
        },
        mdl_pic: false,
        pic_data: null,

        list_bidang : [],

      

        tipeku: null,

  
  
       
        list_data : [],
  
        page_first: 1,
        page_last: 0,
        page_limit : 10,
        cari_value: "",
        cek_load_data : true,
  
        mdl_add: false,
        mdl_edit: false,
        mdl_hapus : false,
        btn_add: false,
      }
    },
    methods: {

      lihatPIC(users_id) {
          fetch(this.$store.state.url.DATA_MITRA + "viewPIC", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({ users_id })
          })
            .then(res => res.json())
            .then(res_data => {
              if (res_data.success) {
                this.pic_data = res_data.data;
                this.mdl_pic = true;
              } else {
                this.$q.notify({ type: "negative", message: res_data.message });
              }
            })
            .catch(err => {
              console.error(err);
              this.$q.notify({ type: "negative", message: "Gagal ambil data PIC" });
            });
        },

      getBidang() {
        fetch(this.$store.state.url.DATA_MITRA + "viewBidang", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({})
        })
          .then(res => res.json())
          .then(res_data => {
            console.log("📌 hasil bidang:", res_data); // debug
            this.list_bidang = res_data.data || [];
          });
      },

  
      getView() {
          fetch(this.$store.state.url.DATA_MITRA + "view", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              page_limit: this.page_limit,
              data_ke: this.data_ke,
              cari_value: this.cari_value,
              master_bidang_usaha: this.filterku.master_bidang_usaha 
            })
          })
            .then(res => res.json())
            .then(res_data => {
              this.list_data = res_data.data;
              this.jml_data = res_data.jml_data;
              this.total_data = res_data.total_data;
            });
        },
  
  
      // addData : function() {
      //   fetch(this.$store.state.url.DATA_MITRA + "addData", {
      //       method: "POST",
      //       headers: {
      //         "content-type": "application/json",
      //         authorization: "kikensbatara " + localStorage.token
      //       },
      //       body: JSON.stringify(this.form)
      //   }).then(res_data => {
      //       this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
      //       this.getView();
      //   });
      // },
  
  
      editData : function(){
        fetch(this.$store.state.url.URL_DM_BID + "editDataForce", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
            this.getView();
        });
      },
  
      removeData : function(E){
        fetch(this.$store.state.url.URL_DM_BID + "removeDataForce", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({id : this.form.id})
        }).then(res_data => {
            this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
            this.getView();
        });
  
      },
  
      selectData : function(data){

        console.log(data);
          this.form.id = data.id;
          this.form.uraian = data.uraian;
      },
  
  
    
      // ====================================== PAGINATE ====================================
          Notify : function(message, positive, icon){
            this.$q.notify({
              message: message,
              color: positive,
              icon: icon,
              position : 'top',
              timeout: 500,
            })
          },
          btn_prev : function(){
              this.cek_load_data = true;
              if(this.page_first>1){
                  this.page_first--
              }else{
                  this.page_first = 1;
              }
              this.getView();
          },
  
          btn_next : function(){
              if(this.page_first >= this.page_last){
                  this.page_first == this.page_last
              }else{
                  this.page_first++;
              }
              this.getView();
          },
  
          cari_data : function(){
              this.page_first = 1;
              this.getView();
          },

            indexing : function(index){
                var idx = ((this.page_first-1)*this.page_limit)+index
                return idx
            },
  
  
      // ====================================== PAGINATE ====================================
  
  
    },
  
    mounted () {
      this.getView();
      this.getBidang();

    },
  }
  